import { render, staticRenderFns } from "./SRadio.vue?vue&type=template&id=be64b820&scoped=true&"
import script from "./SRadio.vue?vue&type=script&lang=js&"
export * from "./SRadio.vue?vue&type=script&lang=js&"
import style0 from "./SRadio.vue?vue&type=style&index=0&id=be64b820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be64b820",
  null
  
)

export default component.exports